import { ContactUsFormFactoryConfig } from './contact-us-form-factory.config';
import { ContactUsFormApiAbstract } from '../domain/repository/contact-us-form-api.abstract';

export const contactUsFormFactory = (apiService: ContactUsFormApiAbstract) =>
  new ContactUsFormFactoryConfig(apiService).initContactUsFormUseCases();
